/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import MediumHeading from 'domain/gpo/cockpit/instance/Show/MediumHeading';
import ModificationTokenButton from 'domain/gpo/cockpit/instance/Show/token/shared/ModificationTokenButton';
import useProcessInstanceTokenService, {
  ProcessInstanceTokenAction,
} from 'domain/gpo/cockpit/instance/Show/token/processInstanceTokenService';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import ModificationTokenPositionForm from 'domain/gpo/cockpit/instance/Show/token/ModificationTokenPositionForm';
import { CreateForm } from 'framework/form';
import Box from '@mui/material/Box';

const ModificationTokenPositions = () => {
  const processInstanceId = useProcessInstanceId();
  const [action, setAction] = useState(ProcessInstanceTokenAction.CREATE);
  const { create, recreate, move, kill } = useProcessInstanceTokenService();

  const showForm = (newAction: ProcessInstanceTokenAction) => () => {
    setAction(newAction);
  };

  const isActive = useCallback(
    (actionName: string) => {
      return actionName === action;
    },
    [action],
  );

  const submitFunc = () => {
    switch (action) {
      case ProcessInstanceTokenAction.CREATE:
        return create;
      case ProcessInstanceTokenAction.RECREATE:
        return recreate;
      case ProcessInstanceTokenAction.MOVE:
        return move;
      case ProcessInstanceTokenAction.KILL:
        return kill;
      default:
        throw new Error(`Unknown action: ${action}`);
    }
  };

  const renderTokenButton = (actionName: ProcessInstanceTokenAction, label: string) => (
    <ModificationTokenButton isActive={isActive(actionName)} onClick={showForm(actionName)} label={label} />
  );

  return (
    <>
      <Box sx={{ '& > *': { display: 'inline-block' } }}>
        <MediumHeading>Token Modifications: {action}</MediumHeading>
      </Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          borderTop: '1px solid',
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderColor: 'border.medium',
        }}
      >
        {renderTokenButton(ProcessInstanceTokenAction.CREATE, 'Create token')}
        {renderTokenButton(ProcessInstanceTokenAction.RECREATE, 'Recreate token')}
        {renderTokenButton(ProcessInstanceTokenAction.MOVE, 'Move token')}
        {renderTokenButton(ProcessInstanceTokenAction.KILL, 'Kill token')}
      </Box>

      <Box
        sx={{
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderColor: 'border.medium',
        }}
      >
        <Box sx={{ margin: '20px 20px 0 !important' }}>
          <CreateForm
            submitFormFunc={submitFunc()}
            initialData={{ instanceId: processInstanceId }}
            afterSubmit={{
              message: 'You are awesome! The action was performed correctly!',
            }}
          >
            <ModificationTokenPositionForm action={action} processInstanceId={processInstanceId} />
          </CreateForm>
        </Box>
      </Box>
    </>
  );
};

export default ModificationTokenPositions;
